import axios from "axios";

export const apiClient = axios.create({
	baseURL: process.env.DOMAIN_API,
	withCredentials: true,
})


export function getOne(module, id) {
	return apiClient.get(`${module}${id ? ('/' + id) : ''}`);
}

export function getOneBy(module, byProperty, byValue) {
	return apiClient.get(`${module}?${byProperty}=${byValue}`);
}

export function getAllBy(module, byProperty, byValue) {
	return apiClient.get(`${module}?${byProperty}=${byValue}`);
}

export function searchOneBy(module, searchProperty, searchQuery) {
	let url = "";

	if (searchQuery && searchProperty) {
		url += `searchProperty=${searchProperty}&searchQuery=${searchQuery}`
	}

	return apiClient.get(`${module}?${url}&one=1`);
}

export function getAll(module, searchProperty, searchQuery, maxResults = 10) {
	let url = "";

	if (searchQuery && searchProperty) {
		url += `?${searchProperty}=${searchQuery}`

		url += maxResults ? `&maxResults=${maxResults}` : '';
	}

	return apiClient.get(`${module}${url}`);
}

export function createOne(module, data) {
	return apiClient.post(module, data);
}

export function updateOne(module, data) {
	return apiClient.put(module, data);
}

export function deleteOne(module, id) {
	return apiClient.delete(module + '/' + id);
}

